import React, {useEffect, useState} from "react";
import {ErrorToast, SuccessToast} from "../../shared/toasters/toasters";
import {AdminSiteSettingsService} from "./service";
import {CreateForm, ISettingsCategory} from "./components/CreateForm";
import {useTranslation} from "react-i18next";
import {ISiteSettings} from "./interface";

export const AdminSiteSettings = () => {
    const {t} = useTranslation();

    const [triggerUpdate, setTriggerUpdate] = useState(false);
    const [inputs, setInputs] = useState<ISiteSettings[]>([]);
    const submitHandler = (indexKey: number) => {
        AdminSiteSettingsService.create(inputs[indexKey])
            .then(() => {
                SuccessToast(t(`settings.successfully_saved`));
                setTriggerUpdate(!triggerUpdate);
            })
            .catch(ErrorToast);
    };

    useEffect(() => {
        AdminSiteSettingsService.getAll()
            .then((response) => {
                const {data} = response;
                setInputs(data?.siteSettings?.map((siteSetting: ISiteSettings) => ({
                    ...siteSetting,
                    category: (siteSetting?.category as ISettingsCategory)?.id
                })));
            })
            .catch((error) => ErrorToast(error));
    }, [triggerUpdate]);

    return (
        <CreateForm
            state={inputs}
            setState={setInputs}
            submitHandler={submitHandler}
        />
    );
};
